var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDotsMenu = function SvgDotsMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 1.872c0 1.034-.895 1.871-2 1.871s-2-.837-2-1.87C0 .837.895 0 2 0s2 .838 2 1.872M4 8c0 1.034-.895 1.871-2 1.871S0 9.033 0 8s.895-1.871 2-1.871S4 6.967 4 8M4 14.128C4 15.162 3.105 16 2 16s-2-.838-2-1.872c0-1.034.895-1.871 2-1.871s2 .837 2 1.87"
  }))));
};
export default SvgDotsMenu;